<template>
    <rkm-modal
        :loading="loading"
        :title="`Cadastro de entrada inicial (${material.descricao})`"
        extraLarge
        ref="Modal"
    >
        <Form
            :data="{form}"
            :material="material"
            @save="handleSave"
            ref="Form"
        />

        <List
            :entradas="material.entradas"
        />

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="!!loading || material.entradas.length === 0"
                @click="$refs.Form.save()"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'
import List from './List'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Mixins
import { object, repository } from '@/mixins'

export default {
    components: { Form, List },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    created() {

        this.repositories = {
            entradaInicial: this.getConectaSusRepository('almoxarifado.entradaInicial')
        }
    },
    data: () => ({
        form: {
            integracaoBnafarMedicamentos: []
        },
        material: {
            entradas: []
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(material) {

            this.form.integracaoBnafarMedicamentos = []

            this.material = this.clone(material)

            this.$set(this.material, 'entradas', [])

            this.$refs.Modal.show()

            this.getIntegracaoBnafarMedicamentos(this.material.id)
        },
        handleSave() {

            this.$emit('save')
            this.handleExit()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        getIntegracaoBnafarMedicamentos(materialId) {
            this.setLoading()

            const request = {
                listar: 'integracao-bnafar-medicamentos',
                material_id: materialId,
            }

            this.repositories.entradaInicial.list(request)
                .then((response) => this.form.integracaoBnafarMedicamentos = response.data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [object, repository]
}
</script>